import { render, staticRenderFns } from "./MenuOutdentButton.vue?vue&type=template&id=6aa92b54&"
import script from "./MenuOutdentButton.vue?vue&type=script&lang=ts&"
export * from "./MenuOutdentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports